// Single source of truth for the gateable-feature catalogue + plan tiers (frontend).
// Mirrors backend plan_features.py GATEABLE_FEATURES / PLAN_CONFIG. Keep in sync if a flag moves tier.
export const FEATURE_CATALOGUE = [
  { flag: 'expenses', label: 'Expenses', tier: 'Pro' },
  { flag: 'inventory', label: 'Inventory & stock tracking', tier: 'Pro' },
  { flag: 'hr', label: 'HR — Employees, Schedule, Payroll', tier: 'Pro' },
  { flag: 'team_access', label: 'Team access — multiple logins & roles', tier: 'Pro' },
  { flag: 'devices_multi', label: 'Multiple POS devices', tier: 'Pro' },
  { flag: 'kds', label: 'Kitchen Display (KDS)', tier: 'Pro' },
  { flag: 'clock_in', label: 'Clock in / out', tier: 'Pro' },
  { flag: 'custom_payment_methods', label: 'Custom payment methods', tier: 'Pro' },
  { flag: 'subcategories', label: 'Product subcategories', tier: 'Pro' },
  { flag: 'eod_per_till', label: 'Per-till End of Day', tier: 'Pro' },
  { flag: 'table_service', label: 'Table service', tier: 'Premium' },
  { flag: 'reservations', label: 'Reservations & waiting list', tier: 'Premium' },
  { flag: 'analytics', label: 'Advanced analytics', tier: 'Premium' },
  { flag: 'marketing', label: 'Marketing', tier: 'Premium' },
  { flag: 'mobile_sales', label: 'Mobile sales', tier: 'Premium' },
];
export const FEATURE_PLAN = Object.fromEntries(FEATURE_CATALOGUE.map(f => [f.flag, f.tier]));
export const PRO_FLAGS = FEATURE_CATALOGUE.filter(f => f.tier === 'Pro').map(f => f.flag);
export const PREMIUM_FLAGS = FEATURE_CATALOGUE.map(f => f.flag); // premium = all
export const PLAN_FEATURE_DEFAULTS = { basic: [], pro: PRO_FLAGS, premium: PREMIUM_FLAGS };
export const planIncludes = (plan, flag) => (PLAN_FEATURE_DEFAULTS[plan] || []).includes(flag);
